export default "__VITE_ASSET__DNxGXt4q__"